import { Checkbox } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormFieldError from "components/common/form_error/form_field_error";
import React, { useEffect, useState } from "react";

const FormSelect = ({
  label,
  value,
  options,
  onChange,
  errorMessage,
  submitClicked,
  customMapping,
  multiple = false,
  required = false,
  hasError = false,
  disabled = false,
  margin = "normal",
  sx,
}) => {
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(required && value === "" && submitClicked);
  }, [required, value, submitClicked]);

  const handleChange = (event, c) => {
    const selectedValue = multiple ? event : event.target.value;
    onChange(selectedValue, c);
    setError(false); // Clear error when the user selects an option
  };

  return (
    <div>
      <FormControl
        fullWidth
        required={required}
        error={error || hasError}
        margin={margin}
        disabled={disabled}
      >
        <InputLabel style={{ background: "white" }}>{label}</InputLabel>
        {customMapping || (
          <Select
            value={value}
            multiple={multiple}
            onChange={handleChange}
            sx={sx}
            renderValue={
              multiple
                ? (selected) => {
                    const selectedOptionLabels = options
                      ?.filter((item) => selected.includes(item.value))
                      ?.map((item) => item.label);

                    return (
                      <div className="d-flex">
                        {selectedOptionLabels.join(", ")}
                      </div>
                    );
                  }
                : undefined
            }
          >
            {options.map((option, index) => (
              <MenuItem key={index} value={option.value}>
                {multiple && (
                  <Checkbox checked={value?.indexOf(option.value) > -1} />
                )}
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
      {(error || hasError) && (
        <FormFieldError
          errorMessage={errorMessage || `${label} is required.`}
        />
      )}
    </div>
  );
};

export default FormSelect;
